import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { fabric } from 'fabric';

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

export function drawStroke({ fields, canvas, id }) {
  canvas.getObjects().forEach(function (o) {
    if (o.id === 'stroke') {
      canvas.remove(o);
    }
  });

  const { canvas_data } = getScopePage();

  const showStroke = !!canvas_data[id]._data.show_stroke;
  const strokeField = fields.find((f) => f.type === 'Stroke');

  if (strokeField && showStroke) {
    const options = JSON.parse(strokeField.options);
    const stroke_color = options['Option1'] || '#6d6d6d';
    const stroke_width = options['Option2'] || 1;
    const visible = !options['Hidden'];
    const rect = new fabric.Rect({
      id: 'stroke',
      top: 0,
      left: 0,
      order: 0,
      width: canvas_data[id].dimension.width - stroke_width,
      height: canvas_data[id].dimension.height - stroke_width,
      fill: '#00000000',
      stroke: stroke_color,
      strokeWidth: +stroke_width,
      selectable: false,
      evented: false,
      visible
    });
    canvas.add(rect);
    canvas.bringToFront(rect);
  }
}